import '../App.css';

function MailingListButton() {
	return (
		<button className="mailing-list-button" href="/mailing-list">Join Mailing List</button>
	)
}

export default MailingListButton;